@use "ui/styles/sizes";
@use "ui/styles/fonts";
@use "ui/styles/colors";

.root {
  display: flex;
  background-color: transparent;

  &:not(.vertical) {
    flex-direction: row;
  }

  &.vertical {
    flex-direction: column;
  }

  .item {
    &:disabled {
      cursor: not-allowed;
    }
  }

  // Default states for types
  &.primary {
    .item {
      background-color: var(--secondary-background-color);
      border: sizes.$s1 solid var(--border-color);
      color: var(--primary-text-color);

      &[data-pressed] {
        background-color: var(--primary-color);
        border-color: var(--primary-color);
        color: var(--background-color);
      }
    }

    // Hover states
    .item:hover:not(:disabled) {
      border-color: var(
        --primary-color
      ) !important; // Using !important instead of explicitly overriding every iteration of the item
      background-color: var(--hover-background-color, var(--secondary-background-color));
    }

    .item[data-pressed]:hover:not(:disabled) {
      background-color: var(--primary-color);
      border-color: var(--primary-color);
    }
  }

  &.secondary {
    .item {
      border: sizes.$s1 solid var(--border-color);
      color: colors.$gray70;

      &[data-pressed] {
        background-color: colors.$white;
        border-color: colors.$gray40;
        color: var(--primary-color);
      }
    }

    // Hover states
    .item:hover:not(:disabled) {
      color: var(--primary-color);
      border-color: colors.$gray60 !important; // Using !important instead of explicitly overriding every iteration of the item
    }

    .item[data-pressed]:hover:not(:disabled) {
      border-color: colors.$gray40;
    }
  }

  &.tertiary {
    .item {
      border: sizes.$s1 solid var(--border-color);
      color: colors.$gray70;

      &[data-pressed] {
        background-color: colors.$white;
        border-color: colors.$gray40;
        color: colors.$gray90;
      }
    }

    // Hover states
    .item:hover:not(:disabled) {
      color: colors.$gray80;
      border-color: colors.$gray50 !important; // Using !important instead of explicitly overriding every iteration of the item
    }

    .item[data-pressed]:hover:not(:disabled) {
      border-color: colors.$gray40;
    }
  }

  // Disabled states
  &.disabled {
    .item {
      border-color: var(--border-color);
      background-color: var(--secondary-background-color);
      color: var(--secondary-text-color);
      cursor: not-allowed;

      // Disabled and selected, reverse the colors
      &[data-pressed] {
        color: var(--secondary-background-color);
        background-color: var(--secondary-text-color);
        border-color: var(--border-color);
      }
    }
  }
}

.item {
  transition: all 200ms ease-in;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  flex-shrink: 0;
  flex-grow: 1;
  border: sizes.$s1 solid transparent;
  background-color: transparent;
  font-weight: fonts.$medium;
  padding: 0;

  // Horizontal layout (default)
  .root:not(.vertical) & {
    &:first-child {
      border-radius: sizes.$s3 0 0 sizes.$s3;
    }

    &:last-child {
      border-radius: 0 sizes.$s3 sizes.$s3 0;
      border-left-color: transparent;
    }

    &:only-child {
      border-radius: sizes.$s3;
      border: sizes.$s1 solid var(--border-color);
    }

    &:not(:first-child):not(:last-child) {
      border-radius: 0;
      border-left-color: transparent;
    }
  }

  // Vertical layout
  .root.vertical & {
    &:first-child {
      border-radius: sizes.$s3 sizes.$s3 0 0;
    }

    &:last-child {
      border-radius: 0 0 sizes.$s3 sizes.$s3;
      border-top-color: transparent;
    }

    &:only-child {
      border-radius: sizes.$s3;
      border: sizes.$s1 solid var(--border-color);
    }

    &:not(:first-child):not(:last-child) {
      border-radius: 0;
      border-top-color: transparent;
    }
  }

  // Focus states
  &:focus-visible {
    outline: sizes.$s2 solid var(--primary-color);
    outline-offset: sizes.$s2;
    z-index: 1;
  }
}

.itemWrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: sizes.$s4 sizes.$s6;
  min-height: sizes.$s8;
}
